import { Box, Button } from '@mui/material';

export default function GeneralInfoSubmitButton({ isLoading, onSubmit }) {
    return (
        <Box>
            <Button
                variant='contained'
                onClick={onSubmit}
                sx={{ width: 'fit-content' }}
                disabled={isLoading}
            >
                {isLoading ? 'Submitting...' : 'Submit Details'}
            </Button>
        </Box>
    )
}
